export const createSelectedRowsByData = (
  selectedRows: any[],
  data: any[],
  dataKey: string
): Record<string, any>[] => {
  const newSelectedRows: Record<string, any>[] = [];

  //Create hash map from value for optimized search
  const hashMap = new Map<string, Record<string, any>>();

  selectedRows.forEach((row) => {
    hashMap.set(row[dataKey], row);
  });

  // Add already known rows to selection in right order
  data.forEach((row) => {
    const foundRow = hashMap.get(row[dataKey]);

    if (foundRow) {
      newSelectedRows.push(foundRow);
      // Consume the entry so a duplicated key in data can't add the row twice
      hashMap.delete(row[dataKey]);
    }
  });

  // Selected rows outside the loaded window (a sort/filter pushed them out) —
  // keep them, a checkbox click elsewhere must not silently drop them.
  hashMap.forEach((row) => {
    newSelectedRows.push(row);
  });

  return newSelectedRows;
};
